import React, { useState, useEffect } from 'react';
import {
  Table,
  Card,
  Button,
  Space,
  Tag,
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  Typography,
  message,
  Popconfirm,
  Tooltip,
  Descriptions,
  Divider
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  RocketOutlined,
  EyeOutlined,
  ReloadOutlined,
  GlobalOutlined,
  DatabaseOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { api } from '../services/api';
import config from '../config/config';
import axios from 'axios';
const { Title, Text } = Typography;
const { Option } = Select;

const Conjuntos = () => {
  // Estados principales
  const [conjuntos, setConjuntos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [detalleVisible, setDetalleVisible] = useState(false);
  const [editando, setEditando] = useState(false);
  const [conjuntoSeleccionado, setConjuntoSeleccionado] = useState(null);
  const [form] = Form.useForm();
  const [deployingId, setDeployingId] = useState(null);
  const [showDeployModal, setShowDeployModal] = useState(false);
  const [conjuntoADeployar, setConjuntoADeployar] = useState(null);

  // Determinar si es móvil
  const isMobile = window.innerWidth <= 768;

  // Cargar conjuntos
 // Cargar conjuntos
const cargarConjuntos = async () => {
  try {
    setLoading(true);
    
    // 🔥 USAR AXIOS DIRECTAMENTE PARA DEBUG
    const token = localStorage.getItem('horeb_admin_token');
    const url = '/api/conjuntos';
    
    console.log('🚀 URL directa:', url);
    console.log('🔑 Token:', token ? token.substring(0, 20) + '...' : 'NO TOKEN');
    
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('✅ Respuesta directa:', response.data);
    
    if (response.data.success) {
  console.log('📊 Datos recibidos:', response.data.data);
  
  // Filtrar conjuntos eliminados
  const conjuntosActivos = response.data.data.filter(conjunto => 
    conjunto.estado !== 'eliminado'
  );
  
  setConjuntos(conjuntosActivos);
      message.success('Conjuntos cargados exitosamente');
    } else {
      console.error('❌ Response no exitosa:', response.data);
      message.error('Error al cargar conjuntos');
    }
  } catch (error) {
    console.error('💥 Error completo:', error);
    console.error('💥 Error response:', error.response?.data);
    console.error('💥 Error status:', error.response?.status);
    const errorMsg = error.response?.data?.mensaje || 'Error de conexión al cargar conjuntos';
    message.error(errorMsg);
  } finally {
    setLoading(false);
  }
};

  // Cargar datos al inicializar
  useEffect(() => {
    cargarConjuntos();
  }, []);

  // Abrir modal para crear/editar
  const abrirModal = (conjunto = null) => {
    setEditando(!!conjunto);
    setConjuntoSeleccionado(conjunto);
    setModalVisible(true);
    
    if (conjunto) {
      form.setFieldsValue({
        nombre: conjunto.nombre,
        dominio: conjunto.dominio,
        email_contacto: conjunto.email_contacto,
        admin_contacto: conjunto.admin_contacto,
        plan_contratado: conjunto.plan_contratado
      });
    } else {
      form.resetFields();
    }
  };

  // Cerrar modal
  const cerrarModal = () => {
    setModalVisible(false);
    setEditando(false);
    setConjuntoSeleccionado(null);
    form.resetFields();
  };

  // Guardar conjunto (crear o actualizar)
const guardarConjunto = async (valores) => {
  console.log('=== DEBUG GUARDAR CONJUNTO ===');
  console.log('Valores del form:', valores);
  console.log('Editando:', editando);
  console.log('Token:', localStorage.getItem('horeb_admin_token'));
  
  try {
    setLoading(true);
    
    if (editando) {
      // Actualizar
      const response = await api.actualizarConjunto(conjuntoSeleccionado.id, valores);
      console.log('Response actualizar:', response);
      
    } else {
      // Crear nuevo
      console.log('Llamando api.crearConjunto...');
      const response = await api.crearConjunto(valores);
      console.log('Response crear:', response);
      
      if (response.success) {
        message.success('Conjunto creado exitosamente');
        cargarConjuntos();
        cerrarModal();
      } else {
        console.error('Error en response:', response);
        message.error(response.mensaje || 'Error al crear conjunto');
      }
    }
  } catch (error) {
    console.error('Error completo:', error);
    console.error('Error stack:', error.stack);
    message.error('Error de conexión: ' + error.message);
  } finally {
    setLoading(false);
  }
  };

  // Eliminar conjunto
  const eliminarConjunto = async (id) => {
    try {
      setLoading(true);
      const response = await api.eliminarConjunto(id, 'Eliminado desde panel admin');
      
      if (response.success) {
        message.success('Conjunto eliminado exitosamente');
        cargarConjuntos();
      } else {
        message.error('Error al eliminar conjunto');
      }
    } catch (error) {
      console.error('Error eliminando conjunto:', error);
      const errorMsg = error.response?.data?.mensaje || 'Error de conexión al eliminar conjunto';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Cambiar estado del conjunto
  const cambiarEstado = async (id, nuevoEstado) => {
    try {
      setLoading(true);
      const response = await api.cambiarEstadoConjunto(id, {
        estado: nuevoEstado,
        motivo: `Cambiado a ${nuevoEstado} desde panel admin`
      });
      
      if (response.success) {
        message.success(`Estado cambiado a ${nuevoEstado} exitosamente`);
        cargarConjuntos();
      } else {
        message.error('Error al cambiar estado');
      }
    } catch (error) {
      console.error('Error cambiando estado:', error);
      const errorMsg = error.response?.data?.mensaje || 'Error de conexión al cambiar estado';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Ver detalles del conjunto
  const verDetalles = (conjunto) => {
    setConjuntoSeleccionado(conjunto);
    setDetalleVisible(true);
  };

const handleDeploy = async (conjunto) => {
  console.log('🚀 [DEPLOY] Iniciando función handleDeploy');
  console.log('📄 Conjunto:', conjunto);
  
  // Guardar el conjunto y mostrar modal
  setConjuntoADeployar(conjunto);
  setShowDeployModal(true);
};

const ejecutarDeploy = async () => {
  if (!conjuntoADeployar) return;
  
  console.log('🚀 Ejecutando deployment para:', conjuntoADeployar.nombre);
  setShowDeployModal(false);
  setDeployingId(conjuntoADeployar.id);
  
  try {
    console.log('📡 Llamando a api.deployConjunto...');
    const response = await api.deployConjunto(conjuntoADeployar.id);
    console.log('✅ Respuesta completa:', response);
    
    if (response && response.success) {
      message.success({
        content: `¡Deployment Exitoso! Conjunto: ${response.data?.conjunto || conjuntoADeployar.nombre}`,
        duration: 6
      });
      
      // Recargar la lista
      await cargarConjuntos();
    } else {
      throw new Error(response?.mensaje || 'Error desconocido en deployment');
    }
    
  } catch (deployError) {
    console.error('❌ Error en deployment:', deployError);
    message.error(`Error en deployment: ${deployError.message}`);
  } finally {
    setDeployingId(null);
    setConjuntoADeployar(null);
  }
};

const cancelarDeploy = () => {
  setShowDeployModal(false);
  setConjuntoADeployar(null);
};

  // Columnas de la tabla
  const columnas = [
    {
      title: 'Conjunto',
      dataIndex: 'nombre',
      key: 'nombre',
      render: (text, record) => (
        <Space direction="vertical" size={0}>
          <Text strong style={{ fontSize: '14px' }}>{text}</Text>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            <GlobalOutlined /> {record.dominio}
          </Text>
        </Space>
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      render: (estado) => {
        const config = {
          activo: { color: 'success', icon: <CheckCircleOutlined /> },
          inactivo: { color: 'default', icon: <ExclamationCircleOutlined /> },
          mantenimiento: { color: 'warning', icon: <SettingOutlined /> },
          suspendido: { color: 'error', icon: <ExclamationCircleOutlined /> }
        };
        
        const { color, icon } = config[estado] || config.inactivo;
        
        return (
          <Tag color={color} icon={icon}>
            {estado.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: 'Plan',
      dataIndex: 'plan_contratado',
      key: 'plan_contratado',
      render: (plan) => {
        const colors = {
          basico: 'blue',
          estandar: 'green',
          premium: 'gold',
          enterprise: 'purple'
        };
        return (
          <Tag color={colors[plan] || 'default'}>
            {plan.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: 'Base de Datos',
      dataIndex: 'bd_nombre',
      key: 'bd_nombre',
      render: (bd_nombre) => (
        <Space>
          <DatabaseOutlined />
          <Text code style={{ fontSize: '12px' }}>{bd_nombre}</Text>
        </Space>
      ),
    },
    {
      title: 'Fecha Creación',
      dataIndex: 'fecha_creacion_formato',
      key: 'fecha_creacion_formato',
      render: (fecha) => (
        <Text style={{ fontSize: '12px' }}>{fecha}</Text>
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Ver detalles">
            <Button
              type="primary"
              ghost
              size="small"
              icon={<EyeOutlined />}
              onClick={() => verDetalles(record)}
            />
          </Tooltip>
          
          <Tooltip title="Editar">
            <Button
              type="default"
              size="small"
              icon={<EditOutlined />}
              onClick={() => abrirModal(record)}
            />
          </Tooltip>
          
          {record.estado === 'activo' ? (
            <Tooltip title="Desactivar">
              <Popconfirm
                title="¿Desactivar conjunto?"
                description="El conjunto pasará a estado inactivo"
                onConfirm={() => cambiarEstado(record.id, 'inactivo')}
                okText="Sí"
                cancelText="No"
              >
                <Button
                  size="small"
                  icon={<ExclamationCircleOutlined />}
                />
              </Popconfirm>
            </Tooltip>
          ) : (
            <Tooltip title="Activar">
              <Popconfirm
                title="¿Activar conjunto?"
                description="El conjunto pasará a estado activo"
                onConfirm={() => cambiarEstado(record.id, 'activo')}
                okText="Sí"
                cancelText="No"
              >
                <Button
                  type="primary"
                  ghost
                  size="small"
                  icon={<CheckCircleOutlined />}
                />
              </Popconfirm>
            </Tooltip>
          )}

                {/* MOVER LOS BOTONES DEPLOY Y VER SITIO AQUÍ DENTRO */}
      {record.estado === 'configurado' && (
        <Tooltip title="Desplegar conjunto">
          <Button 
            type="primary"
            icon={<RocketOutlined />}
            onClick={() => handleDeploy(record)}
            size="small"
            loading={deployingId === record.id}
          >
            Deploy
          </Button>
        </Tooltip>
      )}
       {record.estado === 'activo' && (
        <Tooltip title="Ver sitio">
          <Button 
            icon={<GlobalOutlined />}
            onClick={() => window.open(`https://${record.dominio}`, '_blank')}
            size="small"
          >
            Ver Sitio
          </Button>
        </Tooltip>
      )}
          
          <Tooltip title="Eliminar">
            <Popconfirm
              title="¿Eliminar conjunto?"
              description="Esta acción no se puede deshacer"
              onConfirm={() => eliminarConjunto(record.id)}
              okText="Sí"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </Tooltip>

        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: isMobile ? '8px' : '0' }}>
      {/* Header */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <Title level={2} style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>
            🏢 Gestión de Conjuntos
          </Title>
          <Text type="secondary" style={{ fontSize: isMobile ? '14px' : '16px' }}>
            Administración de conjuntos residenciales del sistema multitenant
          </Text>
        </Col>
        <Col>
          <Space>
            <Button
              icon={<ReloadOutlined />}
              onClick={cargarConjuntos}
              loading={loading}
            >
              {isMobile ? '' : 'Actualizar'}
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => abrirModal()}
            >
              {isMobile ? '' : 'Nuevo Conjunto'}
            </Button>
          </Space>
        </Col>
      </Row>

      {/* Tabla de conjuntos */}
      <Card>
        <Table
          dataSource={conjuntos}
          columns={columnas}
          loading={loading}
          rowKey="id"
          pagination={{
            total: conjuntos.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} conjuntos`,
          }}
          scroll={{ x: isMobile ? 'max-content' : undefined }}
        />
      </Card>

      {/* Modal de crear/editar */}
      <Modal
        title={editando ? '✏️ Editar Conjunto' : '➕ Nuevo Conjunto'}
        open={modalVisible}
        onCancel={cerrarModal}
        footer={null}
        width={isMobile ? '95%' : 600}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={guardarConjunto}
          requiredMark={false}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="nombre"
                label="Nombre del Conjunto"
                rules={[
                  { required: true, message: 'El nombre es obligatorio' },
                  { min: 3, message: 'Mínimo 3 caracteres' }
                ]}
              >
                <Input placeholder="Ej: Conjunto Residencial Los Rosales" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item

                  name="dominio"
                  label="Subdominio"
                  rules={editando ? [
                    { pattern: /^[a-z0-9-]+$/, message: 'Solo letras minúsculas, números y guiones' }
                  ] : [
                    { required: true, message: 'El subdominio es obligatorio' },
                    { pattern: /^[a-z0-9-]+$/, message: 'Solo letras minúsculas, números y guiones' }
                  ]}
                >
                  <Input 
                    placeholder="ej: rosales" 
                    addonAfter=".horebapps.com"
                    disabled={editando}
                  />
                </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="plan_contratado"
                label="Plan Contratado"
                rules={[{ required: true, message: 'Seleccione un plan' }]}
              >
                <Select placeholder="Seleccionar plan">
                  <Option value="basico">Básico</Option>
                  <Option value="estandar">Estándar</Option>
                  <Option value="premium">Premium</Option>
                  <Option value="enterprise">Enterprise</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email_contacto"
                label="Email de Contacto"
                rules={[
                  { required: true, message: 'El email es obligatorio' },
                  { type: 'email', message: 'Email inválido' }
                ]}
              >
                <Input placeholder="admin@conjunto.com" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="admin_contacto"
                label="Administrador"
                rules={[{ required: true, message: 'El administrador es obligatorio' }]}
              >
                <Input placeholder="Nombre del administrador" />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row justify="end" gutter={8}>
            <Col>
              <Button onClick={cerrarModal}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit" loading={loading}>
                {editando ? 'Actualizar' : 'Crear'} Conjunto
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Modal de detalles */}
      <Modal
        title="📋 Detalles del Conjunto"
        open={detalleVisible}
        onCancel={() => setDetalleVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetalleVisible(false)}>
            Cerrar
          </Button>
        ]}
        width={isMobile ? '95%' : 700}
      >
        {conjuntoSeleccionado && (
          <Descriptions column={isMobile ? 1 : 2} bordered size="small">
            <Descriptions.Item label="Nombre">
              {conjuntoSeleccionado.nombre}
            </Descriptions.Item>
            <Descriptions.Item label="Estado">
              <Tag color={conjuntoSeleccionado.estado === 'activo' ? 'success' : 'default'}>
                {conjuntoSeleccionado.estado.toUpperCase()}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Subdominio">
              <Text code>{conjuntoSeleccionado.dominio}.horebapps.com</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Plan">
              <Tag color="blue">{conjuntoSeleccionado.plan_contratado.toUpperCase()}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Email de Contacto">
              {conjuntoSeleccionado.email_contacto}
            </Descriptions.Item>
            <Descriptions.Item label="Administrador">
              {conjuntoSeleccionado.admin_contacto}
            </Descriptions.Item>
            <Descriptions.Item label="Base de Datos">
              <Text code>{conjuntoSeleccionado.bd_nombre}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Puerto BD">
              {conjuntoSeleccionado.bd_puerto}
            </Descriptions.Item>
            <Descriptions.Item label="Fecha de Creación" span={2}>
              {conjuntoSeleccionado.fecha_creacion_formato}
            </Descriptions.Item>
            <Descriptions.Item label="Propiedades Totales">
              <Text strong>{conjuntoSeleccionado.propiedades_total}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Usuarios Activos">
              <Text strong>{conjuntoSeleccionado.usuarios_activos}</Text>
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>

      {/* Modal de confirmación de deploy */}
      <Modal
        title="🚀 Confirmar Deployment"
        open={showDeployModal}
        onOk={ejecutarDeploy}
        onCancel={cancelarDeploy}
        okText="Sí, Desplegar"
        cancelText="Cancelar"
        confirmLoading={deployingId === conjuntoADeployar?.id}
        width={500}
      >
        {conjuntoADeployar && (
          <div>
            <p>¿Está seguro que desea desplegar el conjunto <strong>{conjuntoADeployar.nombre}</strong>?</p>
            <p>Este proceso creará:</p>
            <ul>
              <li>Base de datos completa (112 tablas)</li>
              <li>VirtualHost configurado</li>
              <li>Sitio web funcional</li>
            </ul>
            <p><strong>Tiempo estimado:</strong> 2-3 minutos</p>
          </div>
        )}
      </Modal>
    </div>
  );
};



export default Conjuntos;